import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { EBaseOrderDirection } from 'common/models/requestModels';
import { IGroupModel } from 'entities/Region/Region.models';
import { regionTransport } from 'entities/Region/Region.transport';

interface IComponentProps {
  value?: string;
  regionId?: string;
  onChange?: (groupId?: string) => void;
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
}

// Group options are scoped to the selected region. No region selected → no options (can't pick
// a group without a region, per MBC-84). Parent is responsible for resetting the group value
// when the region changes (see StoreForm / StoreTablePage).
export const GroupSelector: React.FC<IComponentProps> = ({
  value,
  regionId,
  onChange,
  placeholder,
  disabled,
  allowClear = true,
}) => {
  const [groups, setGroups] = useState<IGroupModel[]>([]);

  useEffect(() => {
    if (!regionId) {
      setGroups([]);

      return;
    }

    let active = true;

    regionTransport
      // ponytail: limit 100 (BE max) so a region's groups beyond the 10th aren't silently dropped.
      .getGroupCollection({ regionId, limit: 100, orderDirection: EBaseOrderDirection.ASC } as any)
      .then((collection) => {
        if (active) {
          setGroups(collection.data);
        }
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, [regionId]);

  return (
    <Select
      allowClear={allowClear}
      showSearch
      className="width-full"
      placeholder={placeholder}
      disabled={disabled || !regionId}
      value={value}
      optionFilterProp="children"
      filterOption={(input, option) => (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())}
      onChange={(val) => onChange?.(val)}
      getPopupContainer={(triggerNode) => triggerNode as HTMLElement}
    >
      {groups.map((group) => (
        <Select.Option key={group.id} value={group.id}>
          {group.name}
        </Select.Option>
      ))}
    </Select>
  );
};
